import React, { useContext } from "react";
import styled from "styled-components";
import { ActivityProvider } from "./ActivityProvider";
import SideBar from "./sidebar/SideBar";
import Map from "./Map";
import { LocationContext } from "../locationData";

const StyledContainer = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  background-color: #fbfbfb;
  display: flex;
`;

function App() {
  const [loading] = useContext(LocationContext);
  return (
    <ActivityProvider>
      <StyledContainer>
        <SideBar />
        {!loading && <Map lat={37.5667892} lon={126.9784204} zoom={12} />}
      </StyledContainer>
    </ActivityProvider>
  );
}

export default App;
